import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { getUserConfiguration } from 'owa-session-store';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let StorageOption: LazyOption = createLazyOption(
    {
        key: 'mailboxStorage',
        titleStringKey: 'optionTitle_storage',
        hideTitleInFullOptions: true,
        searchTermsStringKey: 'optionTitle_storage',
        isHidden: () => getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox,
    },
    lazyFullModule,
    m => m.default
);
export default StorageOption;
